import {
  pageView as segmentPageView,
  trackEvent as segmentTrackEvent,
  identifyUser as segmentIdentifyUser,
  group as segmentGroup,
  onReady as segmentOnReady,
} from 'utils/SegmentAnalytics'

import {
  identifyUser as taplyticsIdentifyUser,
} from 'utils/Taplytics'

import {
  pageView as googleAnalyticsAggregatorPageView,
  trackEvent as googleAnalyticsAggregatorTrackEvent,
  setUser as googleAnalyticsAggregatorSetUser,
} from 'utils/GoogleAnalyticsAggregator'

export interface User {
  user_id: string
  email: string
}

export const pageView = (domain: string, pageName: string) => {
  if (typeof window === 'undefined') {
    return
  }

  googleAnalyticsAggregatorPageView(domain, pageName)
  segmentPageView(domain, pageName)
}

export const trackEvent = (domain: string, customEventName: string, metadata: any) => {
  if (typeof window === 'undefined') {
    return
  }
  segmentTrackEvent(domain, customEventName, metadata)
}

export const trackClickEvent = (domain: string, customEventName: string) => {
  if (typeof window === 'undefined') {
    return
  }

  googleAnalyticsAggregatorTrackEvent(domain, 'ClickEvent', customEventName)
  segmentTrackEvent(domain, 'ClickEvent', { eventName: customEventName })
}

export const group = (id: string, metadata: any) => {
  if (typeof window === 'undefined') {
    return
  }
  segmentGroup(id, metadata)
}

export const setUser = (user: User) => {
  if (typeof window === 'undefined') {
    return
  }

  if (user) {
    const userId = user.user_id
    const email = user.email
    googleAnalyticsAggregatorSetUser(userId)
    segmentIdentifyUser(userId, email)
    taplyticsIdentifyUser(userId, email)
  }
  updateOptimize()
}

const updateOptimize = () => {
  if (typeof window === 'undefined') {
    return
  }

  segmentOnReady(() => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate.login_flow_completed' })
    }

    if (window.gtag) {
      window.gtag('event', 'optimize.callback', {
        callback: (value, name) => group(name, { variant: value }),
      })
    }
  })
}

/**
 * Nov 25 2020
 * Types unavailable for dataLayer.
 * We're probably switching a/b testing frameworks anyway
 */
declare global {
  interface Window {
    dataLayer: any[]
  }
}
